import React from 'react';
import { inject, observer } from "mobx-react";

import SEOSchema from "../../../head/SEOSchema";
import { modelOf } from "../../../../prop-types";
import ConfigStore from "../../../../store/ConfigStore";
import SectionStore from "../../../../store/SectionStore";
import SchemaType from "../../../../types/SchemaType";
import UIStore from "../../../../store/UIStore";
import CommonPage from "../../../../types/CommonPage";

const SEOPageSchema = ({ configStore, sectionStore, uiStore }) => {
  let schemaType = SchemaType.WEB_PAGE;
  let name = configStore.store.name;
  let description = '';

  if (uiStore.currentPage) {
    switch (uiStore.currentPage) {
      case CommonPage.CATEGORY:
      case CommonPage.ON_SALE:
      case CommonPage.NEW_PRODUCTS:
      case CommonPage.POPULAR_PRODUCTS:
      case CommonPage.RECOMMENDED_PRODUCTS:
      case CommonPage.SECTION:
        /* Product listing pages are handled with ProductListSchema */
        schemaType = '';
        break;
      case CommonPage.PRODUCT:
        schemaType = SchemaType.ITEM_PAGE;
        break;
      case CommonPage.ADVANCED_SEARCH:
        schemaType = SchemaType.SEARCH_RESULTS_PAGE;
        break;
      case CommonPage.HOME:
        if (!sectionStore.activeSection) {
          name = configStore.configurationTexts.CONF_SEO_TITLE;
          description = configStore.configurationTexts.CONF_SEO_DESCRIPTION;
        }
        break;
      default:
        break;
    }
  }

  /* Generally add some Page type for every page.
  *   When empty it is handled in some specific component. */
  if (!schemaType) return null;

  const data = {
    '@context': 'https://schema.org',
    '@type': schemaType,
    name: name,
    url: window.location.href,
    ...(description && { description }),
  };

  return <SEOSchema data={data}/>;
};

SEOPageSchema.propTypes = {
  configStore: modelOf(ConfigStore).isRequired,
  sectionStore: modelOf(SectionStore).isRequired,
  uiStore: modelOf(UIStore).isRequired,
};

export default inject(
  'configStore',
  'sectionStore',
  'uiStore',
)(observer(SEOPageSchema));
